import {
  createPostContent, createPostImage, generateCompleteVideoReel,
  createScheduledPost, getPostHistory
} from "@/api/social_media_post";

import LocalStorageService from "@/utils/local_store.js";
import merchant_profile from "@/store/modules/merchant_profile";
import {isResponseOK} from "@/utils/general";
import {parseProductList} from "@/models/products/product";
import {ENUM_STATUS_STRING} from "@/constants/common";


export default {
  namespaced: true,
  state: {
    postType: "",
    selectedHolidays: [],
    onTheDay: false,
    beforeTheDay: false,
    afterTheDay: false,
    selectedBeforeTheDay: "",
    selectedAfterTheDay: "",
    selectedAccounts: "",
    selectedPerks: [],
    selectedDate: "",
    selectedRepeat: "No repeat",
    postContent: "Test Post", // will be set from openAI
    postImages: [],
    videoClips: [],
    finalVideoUrl: "",
    postCount: {},
    shortTermPOstCount:{},
    posts:[],
    postTheme: "",
  },

  mutations: {
    setPostType(state, postType) {
      console.log('[Vuex] setPostType called with:', postType);
      state.postType = postType;
    },
    // (delete scheduled post support removed)
    setPostTheme(state, postTheme) {
      console.log('[Vuex] setPostTheme called with:', postTheme);
      state.postTheme = postTheme;
    },
    setPostContent(state, postContent) {
      state.postContent = postContent;
    },
    setPostImages(state, images) {
      state.postImages = images;
    },
    setVideoClips(state, videoClips) {
      state.videoClips = videoClips;
    },
    setFinalVideoUrl(state, videoUrl) {
      state.finalVideoUrl = videoUrl;
    },
    setOnTheDay(state, onTheDay) {
      state.onTheDay = onTheDay;
    },
    setBeforeTheDay(state, beforeTheDay) {
      state.beforeTheDay = beforeTheDay;
    },
    setAfterTheDay(state, afterTheDay) {
      state.afterTheDay = afterTheDay;
    },
    setSelectedHolidays(state, selectedHolidays) {
      state.selectedHolidays = selectedHolidays;
    },
    setSelectedAccounts(state, selectedAccounts) {
      state.selectedAccounts = selectedAccounts;
    },
    setSelectedPerks(state, selectedPerks) {
      state.selectedPerks = selectedPerks;
    },
    setSelectedDate(state, selectedDate) {
      state.selectedDate = selectedDate;
    },
    setSelectedRepeat(state, selectedRepeat) {
      state.selectedRepeat = selectedRepeat;
    },
    setPostCount(state, postCount) {
      state.postCount = postCount;
    },
    setShortTermPostCount(state, shortTermPostCount) {
      state.shortTermPOstCount = shortTermPostCount;
    },
    setAllPosts(state, posts) {
      state.posts = posts;
    }
  },
  getters: {
    getPostType: (state) => {
      return state.postType;
    },
    getPostTheme: (state) => {
      return state.postTheme;
    },
    getPostContent: (state) => {
      return state.postContent;
    },
    getPostImages: (state) => {
      return state.postImages;
    },
    getVideoClips: (state) => {
      return state.videoClips;
    },
    getFinalVideoUrl: (state) => {
      return state.finalVideoUrl;
    },
    getOnTheDay: (state) => {
      return state.onTheDay;
    },
    getBeforeTheDay: (state) => {
      return state.beforeTheDay;
    },
    getAfterTheDay: (state) => {
      return state.afterTheDay;
    },
    getSelectedHolidays: (state) => {
      return state.selectedHolidays;
    },
    getSelectedPerks: (state) => {
      return state.selectedPerks;
    },
    getSelectedDate: (state) => {
      return state.selectedDate;
    },
    getSelectedRepeat: (state) => {
      return state.selectedRepeat;
    },
    getPostCount: (state) => {
      return state.postCount;
    },
    getShortTermPostCount: (state) => {
      return state.shortTermPOstCount;
    },
    getAllPosts: (state) => {
      return state.posts;
    }

  },
  actions: {

    setPostContent({commit}, content) {
      commit("setPostContent", content);
    },
    setPostImages({commit}, images) {
      commit("setPostImages", images);
    },
    setVideoClips({commit}, videoClips) {
      commit("setVideoClips", videoClips);
    },
    setFinalVideoUrl({commit}, videoUrl) {
      commit("setFinalVideoUrl", videoUrl);
    },
    setPostType({commit}, postType) {
      commit("setPostType", postType);

    },
    setPostTheme({commit}, postTheme) {
      commit("setPostTheme", postTheme);
    },
    setOnTheDay({commit}, onTheDay) {
      commit("setOnTheDay", onTheDay);
    },
    setBeforeTheDay({commit}, beforeTheDay) {
      commit("setBeforeTheDay", beforeTheDay);
    },
    setAfterTheDay({commit}, afterTheDay) {
      commit("setAfterTheDay", afterTheDay);
    },
    setSelectedAccounts({commit}, selectedAccounts) {
      commit("setSelectedAccounts", selectedAccounts);
    },
    setSelectedHolidays({commit}, selectedHolidays) {
      commit("setSelectedHolidays", selectedHolidays);
    },
    setSelectedPerks({commit}, selectedPerks) {
      commit("setSelectedPerks", selectedPerks);
    },
    setSelectedDate({commit}, selectedDate) {
      commit("setSelectedDate", selectedDate);
    },
    setSelectedRepeat({commit}, selectedRepeat) {
      commit("setSelectedRepeat", selectedRepeat);
    },
    setPostCount({commit}, postCount) {
      commit("setPostCount", postCount);
    },
    setShortTermPostCount({commit}, shortTermPostCount) {
      commit("setShortTermPostCount", shortTermPostCount);
    },
    setAllPosts({commit}, posts) {
      commit("setAllPosts", posts);
    },
    createScheduledPost({commit}, data) {

      const {values, onSuccess, onFail} = data;

      return createScheduledPost(values)
        .then(response => {
          console.log(response);
          if (onSuccess) onSuccess(response);
          return response;
        })
        .catch(error => {
          if (onFail) {
            onFail(error?.response || error);
          }
          throw error;
        });
    },

    async loadPostHistory({ commit }, data) {
      console.log("🎯 [Vuex] loadPostHistory CALLED with:", data);

      const { values, fetchAnalytics = true } = data;

      console.log("📡 [Vuex] BEFORE getPostHistory");

      let response = null;
      try {
        response = await getPostHistory(values, fetchAnalytics);
        console.log("📥 [Vuex] AFTER getPostHistory:", response);

        if (isResponseOK(response)) {
          const posts = response.data;
          console.log("✅ [Vuex] Committing posts to state:", posts);
          commit("setAllPosts", posts);
        } else {
          console.warn("❌ [Vuex] Response not OK:", response);
          commit("setAllPosts", []);
        }
      } catch (error) {
        console.error("❌ [Vuex] getPostHistory threw error:", error);
        commit("setAllPosts", []);
      }

      return response;
    },

    async getPostHistory({commit}, data) {
      const {values, fetchAnalytics = true, onSuccess, onFail} = data;
      const response = await getPostHistory(values, fetchAnalytics);
      return response;
    },

    async createPostContent({commit}, data) {
      const {values, onSuccess, onFail} = data;
      const response = createPostContent(values);
      return response;
    },

      async createPostImage({commit}, data) {
          const {values, onSuccess, onFail} = data;
          const response = createPostImage(values);
          return response;
      },

      async generateVideoReel({commit}, data) {
          const {imageUrls, options, onSuccess, onFail} = data;
          try {
              const response = await generateCompleteVideoReel(imageUrls, options);
              if (onSuccess) onSuccess(response);
              return response;
          } catch (error) {
              if (onFail) onFail(error);
              throw error;
          }
      }
  }
};
